import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { ProductIssueType } from 'webapp/enums/enums';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';

interface Args {
	type: 'board' | 'block';
	colors: string[];
}

export default class FetchLoaderComponent extends Component<Args> {
	@service('issues-report') declare issuesReportService: Service.IssuesReport;

	@tracked isLoaded = false;

	issuesReportTimeout: ReturnType<typeof setTimeout> | null = null;

	messages = [
		'Please wait. Preparing your data...',
		'Gathering your analytics data...',
		'Fetching the latest performance data...',
		'Analyzing trends to provide insights...',
		'Compiling your data streams...',
		'Preparing your insights...',
	];

	get gradientStyle() {
		let style = '';
		if (this.args.colors) {
			style = `background-image:linear-gradient(270deg, ${this.args.colors[0]}, ${this.args.colors[1]}, ${this.args.colors[0]});`;
		}
		return htmlSafe(style);
	}

	get randomMessage() {
		const randomIndex = Math.floor(Math.random() * this.messages.length);
		return this.messages[randomIndex];
	}

	@action
	setupView() {
		later(() => {
			this.isLoaded = true;
		}, 1);

		const issuesReportTimeoutDuration = 30 * 1000;
		this.issuesReportTimeout = setTimeout(() => {
			this.issuesReportService.triggerEventIssue({
				type: ProductIssueType.DATA_LOADING_DELAY,
				page: window.location.pathname,
				url: window.location.href,
				errorMessage: `Data for ${this.args.type} did not load after ${issuesReportTimeoutDuration / 1000} seconds`,
				endpoint: 'pusher',
				duration: issuesReportTimeoutDuration,
			});
		}, issuesReportTimeoutDuration);
	}

	@action
	teardownView() {
		if (this.issuesReportTimeout) {
			clearTimeout(this.issuesReportTimeout);
		}
	}
	<template>
		<div
			class="fetch-loader {{unless this.isLoaded 'fading-in'}}"
			{{didInsert this.setupView}}
			{{willDestroy this.teardownView}}
		>
			<div class="fetch-loader-ct">
				<div class="fetch-loader__box">
					<p>{{this.randomMessage}}</p>
					<span style={{this.gradientStyle}}></span>
				</div>
			</div>
		</div>
	</template>
}
